export const productDataVestidos = [
    {
      id: "1Vestidomusculosa",
      imageurl:
      'https://http2.mlstatic.com/D_NQ_NP_811242-MLA49369636503_032022-W.webp',
      name: "Vestido musculosa",
      price: "3000",
      description: "vestidos",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "3500",
      colorbc: "pink",
      color: "black",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
    {
      id: "2VestidoescoteenV",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692991351/vestidoenv_fi6ty7.webp",
      name: "Vestido escote en V",
      price: "3700",
      description: " vestidos",
      color: "black",      
      IsTalla: "Talla",
      IsSale: "Nuevo",      
      colorbc: "pink",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
    {
      id: "3Vestidoestilomoño",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_801731-MLA48080804254_102021-W.webp",
      name: "Vestido estilo moño",
      price: "5000",
      description: "vestidos",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 1,2,3],
      quantity: 1,
    },
    {
      id: "4Vestidomangacorta",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_621640-MLA51570515438_092022-W.webp",
      name: "Vestido manga corta",
      price: "2800",
      description: "vestidos",
      color: "brown",      
      IsTalla: "Talla",
      tallas: [ 1,2, 3, 4, 5 ],
      quantity: 1,
    },
    {
      id: "5Vestidolargodelino",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_837272-MLA52942075831_122022-W.webp",
      name: "Vestido largo de lino",
      price: "5500",
      description: "vestidos",
      color: "nute",      
      IsTalla: "Talla",
      tallas: [ 3, 4 , 5],
      quantity: 1,
    },
    {
      id: "6Vestidodoblefrunce",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_660800-MLA53151865237_012023-W.webp",
      name: "Vestido doble frunce",
      price: "3500",
      description: "vestidos",
      color: "fucsia",       
      IsTalla: "Talla",
      tallas: [ 1,2,3 ],
      quantity: 1,
    },
    {
      id: "7Vestidolargotipocloque",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_945563-MLA53443832771_012023-W.webp",
      name: "Vestido largo tipo cloque",
      price: "7500",
      description: "vestidos",
      color: 'brown',
      tallas: [ 1,2,3,4,5],
      quantity: 1,
    },
    {
      id: "8Vestidoplayerodeencaje",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_990049-MLA53210605030_012023-W.webp",
      name: "Vestido playero de encaje",
      price: "7000",
      description: "vestidos",
      color: "white",
      IsTalla: "Talla",
      tallas: [ 2,3,4 ],
      quantity: 1,
    },
    {
      id: "9Vestidocrusado",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_782578-MLA53398142760_012023-W.webp",
      name: "Vestido crusado ",
      price: "6000",
      description: "vestidos",
      color: "black",
      IsTalla: "Talla",
      tallas: [ 2,3,4,5 ],
      quantity: 1,
    },
    {
      id: "10Vestidolargocrusado",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_780740-MLA48485312017_122021-W.webp",
      name: "Vestido largo crusado ",
      price: "8000",
      description: "vestidos",
      color: "blue-dark",
      IsTalla: "Talla",
      tallas: [ 3,4,5 ],
      quantity: 1,
    },
    {
      id: "11Vestidoconmangalarga",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692991800/vestidomangalarga_f3lbo0.webp",
      name: "Vestido manga larga",
      price: "9000",
      description: "vestidos",
      color: "brown",
      IsTalla: "Talla",
      tallas: [ 1,2 ],
      quantity: 1,
    },
    {
      id: "12Vestidodelino",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_916976-MLA53430523755_012023-W.webp",
      name: "Vestido de lino",
      price: "5000",
      description: "vestidos",
      color: "blue-sky",
      IsTalla: "Talla",
      tallas: [ 1,2,3,4,5 ],
      quantity: 1,
    },
  ];